import * as userApi from 'resources/user/user.api';
import userService from 'resources/user/user.service';
import { sendInvitation } from 'resources/user/workflows/invite';
import { USER_STATUSES } from '../user.constants';

export const updateClient = async (userData) => {
  const client = await userService.getUserById(userData.id);

  if (!client) {
    throw new Error('Client not found');
  }

  if (client.email !== userData.email && client.auth_id) {
    const updateAuthUserEmailResponse = await userApi.updateAuthUserEmail({
      id: client.auth_id,
      email: userData.email,
    });

    if (updateAuthUserEmailResponse.isBadRequest) {
      throw new Error('Failed to update client details. Please try again later.');
    }
  }

  const updateUserResponse = await userService.updateOne({ id: userData.id }, userData);

  if (updateUserResponse.isBadRequest) {
    throw new Error('Failed to update client details. Please try again later.');
  }

  const updatedClient = updateUserResponse.data[0];

  // Send invite to the new email
  if (updatedClient.email !== client.email && updatedClient.status === USER_STATUSES.INVITED) {
    await sendInvitation({
      id: updatedClient.id,
      shouldSendEmail: true,
    });
  }

  return updatedClient;
};
